import { createSelector, createFeatureSelector } from '@ngrx/store'
import { BusinessDetailState, BusinessState } from './business.state'

// Selector to get all businesses from the state
// export const selectAllBusinesses = (state: BusinessState) => state.businesses

// // Selector to get loading state
// export const selectLoadingState = (state: BusinessState) => state.loading

// // Selector to get the error state
// export const selectErrorState = (state: BusinessState) => state.error

// Select the feature state
export const selectBusinessState = createFeatureSelector<BusinessState>('business')

// Selector to get all businesses from the state
export const selectAllBusinesses = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.businesses
)

// Selector to get the total count of businesses
export const selectTotalCount = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.totalCount
)

// Selector to get loading state
export const selectLoadingState = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.loading
)

// Selector to get the error state
export const selectErrorState = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.error
)

// Selector to get the total count of businesses
export const selectActiveCount = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.activeCount
)

// Selector to get the total count of businesses
export const selectInactiveCount = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.inactiveCount
)

// Select a business by id
export const selectBusinessById = (businessId: string) =>
  createSelector(selectAllBusinesses, businesses =>
    businesses.find(business => business.id === businessId)
  )

// Select the feature state
export const selectBusinessDetailState = createFeatureSelector<BusinessDetailState>('business')
export const selectBusinessDetail = createSelector(
  selectBusinessDetailState,
  (state: BusinessDetailState) => state.business
)

export const selectBusinessDetailError = createSelector(
  selectBusinessDetailState,
  (state: BusinessDetailState) => state.error
)

// export const selectBusiness = createSelector(selectBusinessDetailState, state => state.business)

// export const selectLoading = createSelector(selectBusinessDetailState, state => state.loading)

// export const selectError = createSelector(selectBusinessDetailState, state => state.error)
